import { validateTidalLicense } from "@workwave-tidal/foundation/base";
validateTidalLicense();
export * from "@workwave-tidal/foundation/base";
//# sourceMappingURL=index.js.map
